import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";

import {
  ThemeProvider as MuiThemeProvider,
  StyledEngineProvider,
  createTheme,
} from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import { Auth0Provider, Auth0ProviderOptions } from "@auth0/auth0-react";
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import axios from "axios";

import StaleReloadModal from "@features/appVersion/StaleReloadModal";
import { initDeployVersionGuard } from "@features/appVersion/deployVersionGuard";
import "@services/sentry/sentryInit";
import QueryClientProviderWrapper from "@utils/reactQuery/QueryClientProviderWrapper";

import "./Index.css";
import { store } from "./redux/store";
import ProtectedRouterProvider from "./routes/ProtectedRouterProvider";
import DateAdapter from "./utility/DateAdapter";
import themeFile from "./utility/theme";

const theme = createTheme(themeFile as any);

axios.defaults.headers.get["Cache-Control"] = "no-cache";
axios.defaults.timeout = 35000;

const auth0ProviderConfig: Auth0ProviderOptions = {
  domain: import.meta.env.VITE_AUTH0_DOMAIN!,
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID!,
  cacheLocation: "localstorage",
  authorizationParams: {
    redirect_uri: window.location.origin,
  },
};

initDeployVersionGuard();

const root = ReactDOM.createRoot(document.getElementById("root")!);

root.render(
  <QueryClientProviderWrapper>
    {/* Base tab title; route DocTitle/PageTitle prepend and win while mounted. */}
    <title>Ready to Activate</title>
    <Auth0Provider {...auth0ProviderConfig}>
      <StyledEngineProvider>
        <MuiThemeProvider theme={theme}>
          <LocalizationProvider dateAdapter={DateAdapter}>
            <Provider store={store}>
              <StaleReloadModal />
              <ProtectedRouterProvider />
            </Provider>
          </LocalizationProvider>
        </MuiThemeProvider>
      </StyledEngineProvider>
    </Auth0Provider>
    {/* <ReactQueryDevtools /> */}
  </QueryClientProviderWrapper>
);
